import moment from 'moment';

import {NCBI_APIKEY} from '../../../constants';

let REQUESTING = false;

export default async function fetchPubmedSuggestion(pubmedID) {
  if (REQUESTING) {
    return;
  }

  REQUESTING = true;

  const suggestion = _fetchPubmedSuggestion(pubmedID);
  REQUESTING = false;
  return suggestion;
}

async function _fetchPubmedSuggestion(pubmedID) {
  const resp = await fetch(
    'https://eutils.ncbi.nlm.nih.gov/entrez/eutils/esummary.fcgi' +
    `?db=pubmed&id=${pubmedID}&retmode=json&api_key=${NCBI_APIKEY}`
  );
  const json = await resp.json();
  const {result} = json;

  if (!(pubmedID in result)) {
    return null;
  }

  if ('error' in result[pubmedID]) {
    return null;
  }

  let {
    pubdate,
    source: journal,
    authors,
    title
  } = result[pubmedID];

  authors = getAuthors(authors);
  const author = getFirstAuthor(authors);

  const pubmedSuggestion = {
    title,
    author,
    authors,
    journal,
    refYear: moment.utc(pubdate, 'YYYY MMM DD').year(),
    medlineId: pubmedID,
    published: true
  };

  return pubmedSuggestion;
}

function getAuthors(authors) {
  authors = authors.filter(
    ({authtype}) => authtype === 'Author'
  );
  authors = authors.map(({name}) => {
    let lastname = name.split(' ');
    const initials = lastname.pop();
    lastname = lastname.join(' ');
    return {lastname, initials};
  });
  return authors;
}


function getFirstAuthor(authors) {
  let [author] = authors;
  author = `${author.lastname}, ${author.initials}`;
  return author;
}



// WEBPACK FOOTER //
// ./src/views/wizard/reference/pubmed-suggestion.js